import withStyles, { CSSProperties } from "@material-ui/core/styles/withStyles";
import Tooltip from "@material-ui/core/Tooltip";
import classNames from "classnames";
import React, { FunctionComponent, ReactNode } from "react";
import { QuestionIcon } from "Shared/Icons";
import InfoIcon from "src/components/icons/Info";
import styled from "styled-components";
import { useFrame } from "react-frame-component";

const Root = styled("span")`
    align-items: center;
    display: inline-flex;
`;

const styles = (theme: any) => ({
    popper: {
        opacity: 1,
    },
    tooltip: {
        backgroundColor: "#ffffff",
        border: "1px solid #d6d6d6",
        borderRadius: 0,
        boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.2)",
        color: "#434345",
        fontSize: "13px",
        fontWeight: 400,
        lineHeight: "1.33",
        maxWidth: "none",
        opacity: 1,
        padding: "16px 20px",
        textAlign: "left",

        [theme.breakpoints.up("md")]: {
            fontSize: "15px",
            maxWidth: 400,

            "&:before": {
                backgroundColor: "#ffffff",
                border: "1px solid #d6d6d6",
                borderLeft: 0,
                borderTop: 0,
                boxShadow: "4px 2px 5px -2px rgba(0, 0, 0, 0.2)",
                content: '""',
                height: 16,
                position: "absolute",
                transform: "rotate(45deg)",
                width: 16,
            },
        },
    } as CSSProperties,
    tooltipPlacementBottom: {
        [theme.breakpoints.up("md")]: {
            "&:before": {
                boxShadow: "none",
                left: "50%",
                top: -9,
                transform: "translateX(-50%) rotate(225deg)",
            },
        },
    },
    tooltipPlacementLeft: {
        [theme.breakpoints.up("md")]: {
            "&:before": {
                boxShadow: "2px 4px 5px -2px rgba(0, 0, 0, 0.2)",
                right: -9,
                top: "50%",
                transform: "translateY(-50%) rotate(315deg)",
            },
        },
    },
    tooltipPlacementRight: {
        [theme.breakpoints.up("md")]: {
            "&:before": {
                left: -9,
                top: "50%",
                transform: "translateY(-50%) rotate(135deg)",
            },
        },
    },
    tooltipPlacementTop: {
        [theme.breakpoints.up("md")]: {
            "&:before": {
                bottom: -9,
                left: "50%",
                transform: "translateX(-50%) rotate(45deg)",
            },
        },
    },
});

export interface InfoTooltipProps {
    className?: string;
    classes?: any;
    icon?: "info" | "question-mark";
    place?:
        | "bottom-end"
        | "bottom-start"
        | "bottom"
        | "left-end"
        | "left-start"
        | "left"
        | "right-end"
        | "right-start"
        | "right"
        | "top-end"
        | "top-start"
        | "top";
    text?: ReactNode;
}

const InfoTooltip: FunctionComponent<InfoTooltipProps> = ({ className, classes, icon = "info", place, text }) => {
    const iframe = useFrame();

    const icons = {
        info: InfoIcon,
        "question-mark": QuestionIcon,
    };
    const Icon = icons[icon];

    if (text === undefined) {
        return null;
    }

    return (
        <Root className={classNames(className)} data-e2e="tooltip">
            <Tooltip
                classes={{
                    popper: classes.popper,
                    tooltip: classes.tooltip,
                    tooltipPlacementBottom: classes.tooltipPlacementBottom,
                    tooltipPlacementLeft: classes.tooltipPlacementLeft,
                    tooltipPlacementRight: classes.tooltipPlacementRight,
                    tooltipPlacementTop: classes.tooltipPlacementTop,
                }}
                disableTouchListener={true}
                enterDelay={100}
                interactive={false}
                placement={place}
                title={text}
                PopperProps={{ container: iframe.document.body }}
            >
                <span>
                    <Icon style={{ color: "inherit", fontSize: "inherit" }} />
                </span>
            </Tooltip>
        </Root>
    );
};

export default withStyles(styles)(InfoTooltip);
